import { render, staticRenderFns } from "./GuidelineRevisionHistoryTable.vue?vue&type=template&id=5d117528&scoped=true&"
import script from "./GuidelineRevisionHistoryTable.vue?vue&type=script&lang=js&"
export * from "./GuidelineRevisionHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./GuidelineRevisionHistoryTable.vue?vue&type=style&index=0&id=5d117528&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d117528",
  null
  
)

export default component.exports